import React from 'react';

import { withConfig } from '../common/Block.jsx';
import Format from '../common/Format.jsx';
import Layout from '../common/Layout.jsx';

function _BlogPost(props) {
    const data = props.data || {};

    let contentClassName;
    let className = 'cont';
    let header = <h1>{data.title}</h1>;
    if (Layout.isFrancisco(props.config)) {
        className += ' cont--blog-post';
        contentClassName = 'cont--blog-post__content';
        header = (
            <div className="cont--blog-post__meta">
                {header}
                <p>
                    <span className="cont--blog-post__meta__date">{Format.Date.getLongMonthYear(data.publishedAt)}</span>
                </p>
            </div>
        );
    } else {
        className += ' cont--artists cont--blog-detail';
        header = (
            <React.Fragment>
                {header}
                <h2>{data.publishedAt}</h2>
            </React.Fragment>
        );
    }
    return (
        <div className="editor__content">
            <div className={className}>
                {header}
                <br />
                <div className={contentClassName} dangerouslySetInnerHTML={{ __html: data.html }} />
            </div>
        </div>
    );
}
const BlogPost = withConfig(_BlogPost);

export default BlogPost;